import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import getCurrentBreakpoint from '@project/shared/utils/breakpoints/js/breakpoints';
import * as $ from "jquery";
var classes = {
    leftControl: 'js-m-scrollable-teaser__left-control',
    rightControl: 'js-m-scrollable-teaser__right-control',
    hiddenControl: 'state-m-scrollable-teaser__slider-arrow-hidden',
    scrollWrapper: "js-m-scrollable-teaser__scroll-wrapper",
    headWrapper: "js-m-scrollable-teaser__head",
    contentWrapper: "js-m-scrollable-teaser__content",
    contentScrollWrapper: "js-m-scrollable-teaser__content-scroll",
    listWrapper: "js-m-scrollable-teaser__list",
    teaserItem: "js-m-scrollable-teaser__list-item",
    disabledSilder: 'm-scrollable-teaser--disabled-silder',
};
var ScrollableTeaserComponent = /** @class */ (function () {
    function ScrollableTeaserComponent(elementRef) {
        this.elementRef = elementRef;
        this._searchParamNameDefault = 'query';
    }
    ScrollableTeaserComponent.prototype.ngOnInit = function () {
        this.updateLinkUrl();
    };
    ScrollableTeaserComponent.prototype.ngAfterViewInit = function () {
        this.$component = $(this.productScrollerElementRef.nativeElement).parent();
        this.initVars();
        this.initScroll();
        this.onScroll();
    };
    ScrollableTeaserComponent.prototype.initVars = function () {
        this.$leftControl = this.$component.find("." + classes.leftControl);
        this.$rightControl = this.$component.find("." + classes.rightControl);
        this.$scrollWrapper = this.$component.find("." + classes.scrollWrapper);
        this.$headWrapper = this.$component.find("." + classes.headWrapper);
        this.$contentWrapper = this.$component.find("." + classes.contentWrapper);
        this.$contentScrollWrapper = this.$component.find("." + classes.contentScrollWrapper);
        this.$listWrapper = this.$component.find("." + classes.listWrapper);
        this.$teaserItem = this.$component.find("." + classes.teaserItem);
    };
    ScrollableTeaserComponent.prototype.onLeftClick = function (event) {
        this.$rightControl.parent().removeClass(classes.hiddenControl);
        this.teaserScrollLeft();
    };
    ScrollableTeaserComponent.prototype.teaserScrollLeft = function () {
        var currentScrollLeft = this.$scrollWrapper.scrollLeft();
        var contentCurrentScrollLeft = this.$contentScrollWrapper.scrollLeft();
        var mobileItemWidth = $(window).width() * 0.768 + 20;
        var viewport = getCurrentBreakpoint();
        if (viewport === 'small') {
            this.$contentScrollWrapper.animate({
                scrollLeft: contentCurrentScrollLeft - mobileItemWidth,
            }, 150);
            if (contentCurrentScrollLeft <= mobileItemWidth) {
                this.$leftControl.parent().addClass(classes.hiddenControl);
            }
        }
        else {
            this.$scrollWrapper.animate({
                scrollLeft: currentScrollLeft - 272,
            }, 150);
            if (currentScrollLeft <= 272) {
                this.$leftControl.parent().addClass(classes.hiddenControl);
            }
        }
    };
    ScrollableTeaserComponent.prototype.onRightClick = function (event) {
        this.$leftControl.parent().removeClass(classes.hiddenControl);
        this.teaserScrollRight();
    };
    ScrollableTeaserComponent.prototype.teaserScrollRight = function () {
        var currentScrollLeft = this.$scrollWrapper.scrollLeft();
        var contentCurrentScrollLeft = this.$contentScrollWrapper.scrollLeft();
        var mobileItemWidth = $(window).width() * 0.768 + 20;
        var maxScrollArea = this.$headWrapper.width() + this.$contentWrapper.width() - this.$scrollWrapper.width();
        var maxContentScrollArea = this.$listWrapper.width() - this.$contentScrollWrapper.width();
        var viewport = getCurrentBreakpoint();
        if (viewport === 'small') {
            this.$contentScrollWrapper.animate({
                scrollLeft: contentCurrentScrollLeft + mobileItemWidth,
            }, 150);
            if (contentCurrentScrollLeft + mobileItemWidth > maxContentScrollArea - 1) {
                this.$rightControl.parent().addClass(classes.hiddenControl);
            }
        }
        else {
            this.$scrollWrapper.animate({
                scrollLeft: currentScrollLeft + 365,
            }, 150);
            if (currentScrollLeft + 365 > maxScrollArea - 1) {
                this.$rightControl.parent().addClass(classes.hiddenControl);
            }
        }
    };
    ScrollableTeaserComponent.prototype.initScroll = function () {
        var viewport = getCurrentBreakpoint();
        if (viewport === 'small') {
            if (this.$listWrapper.width() < this.$contentScrollWrapper.width()) {
                this.$component.addClass(classes.disabledSilder);
            }
            else {
                this.$component.removeClass(classes.disabledSilder);
            }
        }
        else {
            if (this.$headWrapper.width() + this.$contentWrapper.width() < this.$scrollWrapper.width()) {
                this.$component.addClass(classes.disabledSilder);
            }
            else {
                this.$component.removeClass(classes.disabledSilder);
            }
        }
    };
    ScrollableTeaserComponent.prototype.onScroll = function () {
        var _this = this;
        var viewport = getCurrentBreakpoint();
        this.$contentScrollWrapper.on('scroll', function () {
            var contentCurrentScrollLeft = _this.$contentScrollWrapper.scrollLeft();
            var maxContentScrollArea = _this.$listWrapper.width() - _this.$contentScrollWrapper.width();
            if (viewport === 'small') {
                if (contentCurrentScrollLeft > 0) {
                    _this.$leftControl.parent().removeClass(classes.hiddenControl);
                }
                else if (contentCurrentScrollLeft == 0) {
                    _this.$leftControl.parent().addClass(classes.hiddenControl);
                }
                if (contentCurrentScrollLeft > maxContentScrollArea - 1) {
                    _this.$rightControl.parent().addClass(classes.hiddenControl);
                }
                else if (contentCurrentScrollLeft < maxContentScrollArea - 1) {
                    _this.$rightControl.parent().removeClass(classes.hiddenControl);
                }
            }
        });
        this.$scrollWrapper.on('scroll', function () {
            var currentScrollLeft = _this.$scrollWrapper.scrollLeft();
            var maxScrollArea = _this.$headWrapper.width() + _this.$contentWrapper.width() - _this.$scrollWrapper.width();
            if (currentScrollLeft > 0) {
                _this.$leftControl.parent().removeClass(classes.hiddenControl);
            }
            else if (currentScrollLeft == 0) {
                _this.$leftControl.parent().addClass(classes.hiddenControl);
            }
            if (currentScrollLeft > maxScrollArea - 1) {
                _this.$rightControl.parent().addClass(classes.hiddenControl);
            }
            else if (currentScrollLeft < maxScrollArea - 1) {
                _this.$rightControl.parent().removeClass(classes.hiddenControl);
            }
        });
    };
    ScrollableTeaserComponent.prototype.updateLinkUrl = function () {
        if (this.searchText !== undefined) {
            this.updateParamValue();
            var queryParam = '?' + this.searchParamName + '=' + this.searchText + ':' + this.sortOrder;
            if (this.introButton) {
                this.introButton.href = this.introBtnOriginalHref + queryParam;
            }
            if (this.outroButton) {
                this.outroButton.href = this.outroBtnOriginalHref + queryParam;
            }
        }
    };
    ScrollableTeaserComponent.prototype.updateParamValue = function () {
        this.productScroller.queryParameterKey !== undefined
            ? (this.searchParamName = this.productScroller.queryParameterKey)
            : (this.searchParamName = this.searchParamNameDefault);
    };
    Object.defineProperty(ScrollableTeaserComponent.prototype, "introTitle", {
        get: function () {
            return this.productScroller.introTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "introDescription", {
        get: function () {
            return this.productScroller.introDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "introButton", {
        get: function () {
            return this.productScroller.introButton;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "outroTitle", {
        get: function () {
            return this.productScroller.outroTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "outroDescription", {
        get: function () {
            return this.productScroller.outroDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "outroButton", {
        get: function () {
            return this.productScroller.outroButton;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "searchResult", {
        get: function () {
            return this.productScroller.results;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "ReadMoreLabel", {
        get: function () {
            return this.productScroller.readMoreLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "searchParamName", {
        get: function () {
            return this._searchParamName;
        },
        set: function (value) {
            this._searchParamName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "searchParamNameDefault", {
        get: function () {
            return this._searchParamNameDefault;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "introBtnOriginalHref", {
        get: function () {
            return this.getButtonOriginalHref(this.introButton);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollableTeaserComponent.prototype, "outroBtnOriginalHref", {
        get: function () {
            return this.getButtonOriginalHref(this.outroButton);
        },
        enumerable: true,
        configurable: true
    });
    ScrollableTeaserComponent.prototype.getButtonOriginalHref = function (button) {
        if (button) {
            var href = button.href;
            if (href.indexOf("?") > 0) {
                href = href.substring(0, href.indexOf("?"));
            }
            return href;
        }
    };
    ScrollableTeaserComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-scrollable-teaser',
                    template: "<div class=\"m-scrollable-teaser m-scrollable-teaser--products\" data-t-name=\"ScrollableTeaser\" #productScroller>\r\n\t<div class=\"m-scrollable-teaser__body\">\r\n\t\t<div class=\"m-scrollable-teaser__scroll-wrapper js-m-scrollable-teaser__scroll-wrapper\">\r\n\t\t\t<div *ngIf=\"introTitle || introDescription || introButton\"\r\n\t\t\t\tclass=\"m-scrollable-teaser__head js-m-scrollable-teaser__head\">\r\n\r\n\t\t\t\t<cov-heading *ngIf=\"introTitle\" [level]=\"introTitle.level\" [modifier]=\"introTitle.modifier\"\r\n\t\t\t\t\t[text]=\"introTitle.text\" [class]=\"introTitle.class\"></cov-heading>\r\n\t\t\t\t<p *ngIf=\"introDescription\" class=\"m-scrollable-teaser__desc\" [innerHTML]=\"introDescription\"></p>\r\n\t\t\t\t<cov-button *ngIf=\"introButton\" [buttonlink]=\"introButton.buttonlink\" [text]=\"introButton.text\"\r\n\t\t\t\t\t[href]=\"introButton.href\" [modifier]=\"introButton.modifier\" [class]=\"introButton.class\">\r\n\t\t\t\t</cov-button>\r\n\r\n\t\t\t</div>\r\n\t\t\t<div class=\"m-scrollable-teaser__content js-m-scrollable-teaser__content\">\r\n\t\t\t\t<div class=\"m-scrollable-teaser__slider-left state-m-scrollable-teaser__slider-arrow-hidden\">\r\n\t\t\t\t\t<a class=\"m-scrollable-teaser__left-control js-m-scrollable-teaser__left-control\"\r\n\t\t\t\t\t\t(click)=\"onLeftClick($event)\"></a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"m-scrollable-teaser__slider-right\">\r\n\t\t\t\t\t<a class=\"m-scrollable-teaser__right-control js-m-scrollable-teaser__right-control\"\r\n\t\t\t\t\t\t(click)=\"onRightClick($event)\"></a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"m-scrollable-teaser__content-scroll js-m-scrollable-teaser__content-scroll\">\r\n\t\t\t\t\t<ul class=\"m-scrollable-teaser__list js-m-scrollable-teaser__list\">\r\n\t\t\t\t\t\t<ng-container *ngFor=\"let result of searchResult\">\r\n\t\t\t\t\t\t\t<li class=\"m-scrollable-teaser__list-item js-m-scrollable-teaser__list-item\">\r\n\t\t\t\t\t\t\t\t<div class=\"m-scrollable-teaser-item\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"m-scrollable-teaser-item__text-area\">\r\n\t\t\t\t\t\t\t\t\t\t<cov-heading [level]=\"result.title.level\" [modifier]=\"result.title.modifier\"\r\n\t\t\t\t\t\t\t\t\t\t\t[text]=\"result.title.text\">\r\n\t\t\t\t\t\t\t\t\t\t</cov-heading>\r\n\t\t\t\t\t\t\t\t\t\t<p class=\"m-scrollable-teaser-item__description\"\r\n\t\t\t\t\t\t\t\t\t\t\t[innerHTML]=\"result.description\"></p>\r\n\t\t\t\t\t\t\t\t\t\t<cov-link [class]=\"result.link.class\" [text]=\"ReadMoreLabel\"\r\n\t\t\t\t\t\t\t\t\t\t\t[href]=\"result.link.href\"></cov-link>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t</ng-container>\r\n\r\n\t\t\t\t\t\t<li *ngIf=\"outroTitle || outroDescription || outroButton\"\r\n\t\t\t\t\t\t\tclass=\"m-scrollable-teaser__list-item\">\r\n\t\t\t\t\t\t\t<div class=\"m-scrollable-teaser-item m-scrollable-teaser-item--explore\">\r\n\t\t\t\t\t\t\t\t<div class=\"m-scrollable-teaser-item__text-area\">\r\n\t\t\t\t\t\t\t\t\t<cov-heading *ngIf=\"outroTitle\" [level]=\"outroTitle.level\"\r\n\t\t\t\t\t\t\t\t\t\t[modifier]=\"outroTitle.modifier\" [text]=\"outroTitle.text\"\r\n\t\t\t\t\t\t\t\t\t\t[class]=\"outroTitle.class\">\r\n\t\t\t\t\t\t\t\t\t</cov-heading>\r\n\t\t\t\t\t\t\t\t\t<p *ngIf=\"outroDescription\" class=\"m-scrollable-teaser__desc\"\r\n\t\t\t\t\t\t\t\t\t\t[innerHTML]=\"outroDescription\"></p>\r\n\t\t\t\t\t\t\t\t\t<cov-button *ngIf=\"outroButton\" [buttonlink]=\"outroButton.buttonlink\"\r\n\t\t\t\t\t\t\t\t\t\t[text]=\"outroButton.text\" [href]=\"outroButton.href\"\r\n\t\t\t\t\t\t\t\t\t\t[modifier]=\"outroButton.modifier\" [class]=\"outroButton.class\"></cov-button>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</li>\r\n\t\t\t\t\t</ul>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n</div>"
                }] }
    ];
    /** @nocollapse */
    ScrollableTeaserComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    ScrollableTeaserComponent.propDecorators = {
        productScroller: [{ type: Input }],
        searchText: [{ type: Input }],
        sortOrder: [{ type: Input }],
        productScrollerElementRef: [{ type: ViewChild, args: ['productScroller',] }]
    };
    return ScrollableTeaserComponent;
}());
export { ScrollableTeaserComponent };
//# sourceMappingURL=scrollable-teaser.component.js.map